import React from "react";
import PaymentTermsList from "./PaymentTermsList";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";

const PaymentTerms = () => {
  return (
    <NavHeightAdjust>
      <PaymentTermsList />
    </NavHeightAdjust>
  );
};

export default PaymentTerms;
